<template>
  <div class="header-main sides-padding">
    <div class="header-main__container header-search__input container">
      <router-link :to="{ name: 'home' }" class="header-main__logo" title="На главную">
        <FileIconComponent name="logo" />
      </router-link>
      <IconAndTextComponent icon="call" :title="schedule" :value="phone" :link="phone | phone" :big="true" />
      <InputComponent
        @input="$emit('search', search)"
        @focus="$store.state._overlays.searchOverlay = true"
        v-model="search"
        icon-position="right"
        :placeholder="searchPlaceholder"
        class="header-main__search"
        :class="{ 'header-main__search--focus': $store.state._overlays.searchOverlay }"
      />
      <SearchResultsDropdownComponent
        v-show="search"
        :items="products"
        :total="total"
        :search="search"
        v-slot="{ item }"
        buttonTitle="Показать все"
        :route="{ name: 'catalog', query: { title: search } }"
        :loading="loading"
      >
        <ProductCardSearchVersionComponent :data="item" />
      </SearchResultsDropdownComponent>
      <div class="header-main__actions">
        <button
          type="button"
          class="header-main__action header-main__action-mobile header-main__action-search"
          @click="$store.state._overlays.searchOverlay = true"
          title="Поиск по сайту"
        >
          <IconComponent name="search-normal-1" class="icon--thick" />
        </button>
        <router-link
          :to="{ name: 'user', params: { link: 'wishlist' } }"
          class="header-main__action"
          title="Избранное"
        >
          <IconComponent name="heart" class="icon--thick" />
          <span
            v-if="favoritesLength && !$store.state._overlays.searchOverlay"
            class="header-main__action-count"
          >
            {{ favoritesLength }}
          </span>
        </router-link>
        <router-link :to="{ name: 'cart' }" class="header-main__action" title="Корзина">
          <IconComponent name="bag-2" class="icon--thick" />
          <span
            v-if="cartItemsLength && !$store.state._overlays.searchOverlay"
            class="header-main__action-count"
          >
            {{ cartItemsLength }}
          </span>
        </router-link>
        <button @click="showMenu" type="button" class="header-main__action header-main__action-mobile">
          <IconComponent name="menu" />
        </button>
        <button
          v-if="$store.state._overlays.searchOverlay"
          @click="$store.state._overlays.searchOverlay = false"
          class="header-main__action header-main__search-close btn"
        >
          <IconComponent name="close" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import FileIconComponent from "components/FileIconComponent.vue";
import InputComponent from "components/inputs/InputComponent.vue";
import IconComponent from "components/IconComponent.vue";
import IconAndTextComponent from "components/IconAndTextComponent.vue";
import SidenavMenu from "components/menus/components/SidenavMenu.vue";
import SearchResultsDropdownComponent from "components/header/components/SearchResultsDropdownComponent.vue";
import ProductCardSearchVersionComponent from "components/product/ProductCardSearchVersionComponent.vue";

export default {
  name: "HeaderMainComponent",
  props: {
    cartItemsLength: Number,
    products: Array,
    total: Number,
    loading: Boolean,
    searchPlaceholder: String,
  },
  data() {
    return {
      search: null,
    };
  },
  watch: {
    "$route.name"() {
      this.search = null;
    },
    "$route.params"() {
      this.search = null;
    },
  },
  computed: {
    favoritesLength() {
      return this.$store.state.auth.favorites?.length;
    },
    phone() {
      if (
        this.$store.state.marketplace?.communications &&
        this.$store.state.marketplace.communications.length
      ) {
        return this.$store.state.marketplace.communications.find(
          (item) => item.type.code === this.$store.state._types.PHONE
        )?.value;
      }
      return undefined;
    },
    schedule() {
      return this.$store.state.marketplace?.schedule || undefined;
    },
  },
  methods: {
    showMenu() {
      this.$store.state._menus.push({
        component: SidenavMenu,
        options: {},
        alignRight: true,
      });
    },
  },
  components: {
    ProductCardSearchVersionComponent,
    SearchResultsDropdownComponent,
    IconAndTextComponent,
    IconComponent,
    InputComponent,
    FileIconComponent,
  },
};
</script>

<style lang="stylus">
@import "~@/styles/mixins/svg.styl"
.header-main {
  display flex
  align-items center
  justify-content center
  background var(--white)
	height: var(--header-main-height)
  +below(768px) {
    position fixed !important
    top 0
    left 0
    right 0
    z-index 1
  }

  &__container {
    display inline-flex
    align-items center
    justify-content space-between
    padding 10px 0
    gap 30px

    .input {
      flex-grow 1

      &__container {
        border: 2px solid var(--gray)
      }
    }

    .btn {
      flex-shrink 0
    }
  }

  &__search {
    +below(860px) {
      display none
    }

		.input__container {
			border-radius var(--big_radius)
			background var(--gray-light)
		}

    &--focus {
      display inline-flex
      position absolute
      z-index 1
      width calc(100% - 55px)
			padding: 20px 0
			background: var(--white)
			+below(840px) {
				padding: 10px 0
			}
      +below(540px) {
        width calc(100% - 35px)
				padding: 0
      }
    }

    &-close.btn {
      position absolute
      right 0
      z-index 1
      background var(--white)

      .icon {
        width 24px
        height 24px
      }
    }
  }

  &__actions {
    display flex
    align-items center
    gap 10px
    flex-shrink 0
    margin-left auto
  }

  &__action {
    display flex
    align-items center
    justify-content center
    width 50px
    height 50px
    background var(--white)
    border-radius var(--big_radius)
    border: 2px solid var(--gray)
    position relative
    padding 15px
    transition var(--transition)
    cursor pointer
    flex-shrink 0
    +below(540px) {
      width 35px
      height 35px
      padding 8px
      border-radius var(--small_radius)
    }

    &:hover {
      background var(--main-gray)

      .icon svg {
        svg(var(--white))
      }
    }

    &-search {
      +below(540px) {
        display none
      }
    }

    &-mobile {
      +above(861px) {
        display none
      }
    }

    .icon {
      width 20px
      height 20px
      +below(540px) {
        width 16px
        height 16px
      }

      svg {
        svg(var(--main-gray))
      }
    }
  }

  &__action-count {
    display inline-flex
    align-items center
    justify-content center
    text-align center
    absolute right -5px top -5px
    height 18px
    min-width 18px
    background: var(--red);
    border: 1px solid var(--white);
    box-sizing: border-box;
    border-radius: 100px;
    font-weight: 600;
    font-size: 0.75em;
    color: var(--white);
  }

  .icon-text {
    +below(860px) {
      display none
    }
  }

  &__logo {
    flex-shrink 0
    display flex
		width: 100%
		max-width: 223px
    max-height 80px
		+below(840px) {
			max-width: 170px
			max-height 60px
			width auto
			align-items center
		}
    +below(540px) {
			max-width: 125px
      flex-shrink 1
    }

		.file-icon {
			max-width 100%
			max-height 100%
		}

    img {
			height: 100%
			object-fit: contain
    }
  }
}
</style>
